(() => {
  const placeholders = [...document.querySelectorAll('[data-deferred-home-section]')];
  if (!placeholders.length) return;
  const deferredScript = document.currentScript;
  const swiperSrc = deferredScript && deferredScript.dataset.swiperSrc;
  let hasInteracted = false;
  const pending = new Set();
  let swiperPromise;
  const loadSwiper = () => {
    if (window.Swiper || !swiperSrc) return Promise.resolve();
    if (swiperPromise) return swiperPromise;
    swiperPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = swiperSrc;
      script.async = true;
      script.onload = () => {
        document.dispatchEvent(new Event('revival:swiper-ready'));
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return swiperPromise;
  };
  const activateScripts = (section) => section.querySelectorAll('script').forEach((original) => {
    const replacement = document.createElement('script');
    [...original.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    replacement.textContent = original.textContent;
    original.replaceWith(replacement);
  });
  const load = async (placeholder) => {
    if (pending.has(placeholder) || placeholder.dataset.loaded === 'true') return;
    pending.add(placeholder);
    const sectionId = placeholder.dataset.deferredHomeSection;
    try {
      const response = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`, { credentials: 'same-origin' });
      const sections = await response.json();
      const template = document.createElement('template');
      template.innerHTML = sections[sectionId] || '';
      const section = template.content.firstElementChild;
      if (!section) throw new Error('Section markup missing');
      placeholder.replaceWith(section);
      activateScripts(section);
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId } }));
    } catch (error) {
      placeholder.remove();
    } finally {
      pending.delete(placeholder);
    }
  };
  const observer = new IntersectionObserver((entries) => {
    if (!hasInteracted) return;
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        load(entry.target);
      }
    });
  }, { rootMargin: '800px 0px' });
  placeholders.forEach((placeholder) => observer.observe(placeholder));
  const begin = () => {
    hasInteracted = true;
    loadSwiper().catch(() => {});
    placeholders.forEach((placeholder) => {
      if (placeholder.getBoundingClientRect().top < window.innerHeight + 800) {
        observer.unobserve(placeholder);
        load(placeholder);
      }
    });
  };
  ['scroll', 'pointerdown', 'touchstart', 'keydown'].forEach((eventName) => window.addEventListener(eventName, begin, { once: true, passive: true }));
})();
